import { Button, Card, Progress, Space, Tag, Typography } from 'antd';
import type { AiGenerationRequest } from '../../../types/ai-analysis.types';

export default function AiGenerationStatus({
  request,
  onCancel,
  onOpenArtifact,
}: {
  request: AiGenerationRequest;
  onCancel?: () => void;
  onOpenArtifact?: (id: string) => void;
}) {
  const done = request.jobs.filter((job) =>
    ['SUCCEEDED', 'FAILED', 'CANCELED'].includes(job.status)
  ).length;
  return (
    <Card size="small" title={`Solicitação ${request.id}`} extra={<Tag>{request.status}</Tag>}>
      <Progress
        percent={request.jobs.length ? Math.round((done / request.jobs.length) * 100) : 0}
      />
      <Space direction="vertical" style={{ width: '100%' }}>
        {request.jobs.map((job) => (
          <Space key={job.id} wrap>
            <Typography.Text>{job.artifactType}</Typography.Text>
            <Tag>{job.status}</Tag>
            {job.errorMessage && (
              <Typography.Text type="danger">{job.errorMessage}</Typography.Text>
            )}
            {job.artifactId && (
              <Button size="small" onClick={() => onOpenArtifact?.(job.artifactId!)}>
                Revisar
              </Button>
            )}
          </Space>
        ))}
      </Space>
      {request.status === 'ACTIVE' && (
        <Button danger size="small" onClick={onCancel}>
          Cancelar pendentes
        </Button>
      )}
    </Card>
  );
}
